



















































































































    import Vue, {PropType} from 'vue';

    export default Vue.extend({
        name: 'file-list',

        data(): {
            popupVisible: boolean,
            icons: { [key: string]: string | string[] },
        } {
            return {
                popupVisible: false,
                icons: {
                    '.def': 'paperclip',
                    '.s': 'code',
                    'other': ['far', 'file-alt'],
                },
            };
        },

        props: {
            files: { type: Array as PropType<string[]>, default: (): string[] => [] },
            selectedFile: String,
            type: { type: String as PropType<'list'|'popup'>, default: () => 'list' },
        },

        computed: {
            orderedFileList() {
                return this.files.sort((a: string, b: string) : number => {
                    const getOrder = (s: string) : string => {
                        if (s.endsWith('.def'))
                            return '1' + s;
                        else if (s.endsWith('.s'))
                            return '2' + s;
                        else
                            return '3' + s;
                    };
                    return getOrder(a).localeCompare(getOrder(b));
                });
            },

            isPopup() {
                return this.type === 'popup';
            },

            fileListDisplayStyle() {
                if (this.type !== 'popup' || this.popupVisible)
                    return 'inherit';
                else
                    return 'none';
            },
        },

        methods: {
            icon(file: string): string | string[] {
                try {
                    for (const [extension, icon] of Object.entries(this.icons)) {
                        if (file.endsWith(extension))
                            return icon;
                    }
                } catch (e) {
                    // do nothing
                }
                return this.icons.other;
            },

            selectFile(file : string) {
                this.popupVisible = false;
                this.$emit('change', file);
            },

            addFile() {
                const filename = prompt(`Please choose a name for the new file.
Important: only files ending in '.def' or '.s' will be compiled.`);
                if (filename === null)
                    return;
                this.$emit('new-file', filename);
            },
        },
    });
